import React from "react";
import "./contact.css";
import ContactForm from "../../utils/contact_form";

const Contact = () => {
  React.useEffect(() => {
    if (window.location.hash === '#contact') {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div className="video-wrapper" id="contact">
      <video className="background-video"
        src="/space_optimized.mp4"
        autoPlay
        muted
        loop
        playsInline
        id="contact-video"
        poster="/space_poster.jpg"
      />
      <div className="overlay">
        <ContactForm />
      </div>
    </div>
  );
};

export default Contact;
